import * as React from "react"
import {Checkbox} from "../sbhtml/checkbox";
import {toString} from "../utils";
import {CategoryId, CategoryTreeItem} from "./data";

export type CategoryManagerProps = CategoryManagerValueProps & CategoryManagerCallbackProps

export type CategoryManagerValueProps = {
	categories: CategoryTreeItem[]
	selectedCategories: CategoryId[]
}

type CategoryToggle = (value: number|string) => void
export type CategoryManagerCallbackProps = {
	setCategoryCheckbox: CategoryToggle
	unsetCategoryCheckbox: CategoryToggle
}

export const CategoryManager = (props: CategoryManagerProps):JSX.Element => {
	return <div>
		{props.categories.length > 0 && <CategoryManagerInner {...props}/>}
	</div>
}

const CategoryManagerInner = (props: CategoryManagerProps):JSX.Element => {
	const categories = props.categories
	return <ul style={{listStyleType: "none"}}>
		{categories.map((cti: CategoryTreeItem) => {
			const cid = cti.categorySerial
			const checked = props.selectedCategories.find((c) => c == cid) !== undefined
			return <li key={cid}>
				<Checkbox
					label={cti.title}
					checked={checked}
					value={toString(cid)}
					onChange={() => (checked ? props.unsetCategoryCheckbox : props.setCategoryCheckbox)(cid)}
				/>
				{(cti.children !== undefined && cti.children.length > 0) && <CategoryManager {...props} categories={cti.children}/>}
			</li>
		})}
	</ul>
}



// WEBPACK FOOTER //
// ./src/lib/category-manager/presentation.tsx